(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('ProjectType', ProjectType);

    ProjectType.$inject = ['$resource', 'DateUtils'];

    function ProjectType ($resource, DateUtils) {
        var resourceUrl =  'api/project-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ProjectTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getprojecttypebyname = function (data,callback){
		$http.get('api/project-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ProjectTypeSearch', ProjectTypeSearch);

    ProjectTypeSearch.$inject = ['$resource'];

    function ProjectTypeSearch ($resource) {
        var service = $resource('/api/project-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomProjectTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-project-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();